export default "__VITE_ASSET__BEf4v1hh__"